<script setup>
import {ref} from 'vue';
import {Dialog, DialogPanel, DialogTitle, TransitionRoot} from '@headlessui/vue';
import {useI18n} from 'vue-i18n';
import BondDetailContent from '@/components/bonds/BondDetailContent.vue';

/**
 * Detail dluhopisu v modalu – tlačítko „Detail“ ve výběru dluhopisů v kalkulačce onboardingu.
 * Stejný obsah jako stránka /bonds/:id (klient, SO) nebo /advisor/bonds/:id (poradce, ASO), jen bez Koupit;
 * onboarding zůstává otevřený a rozpracovaná kalkulačka se neztratí (přechod na stránku by ji zavřel).
 */
defineProps({
  // dluhopis z nabídky kalkulačky (id, name)
  bond: {type: Object, required: true},
  // pohled poradce (ASO) – jinak klienta (SO)
  advisor: {type: Boolean, default: false},
});
const emit = defineEmits(['close']);

const {t} = useI18n();
const isOpen = ref(true);

function close() {
  isOpen.value = false;
  emit('close');
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <!-- nad modalem výběru dluhopisů (z-index 1060) -->
    <Dialog as="div" @close="close" class="modal show d-block" style="z-index: 1070;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" style="z-index: 1070">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">{{ bond.name }}</DialogTitle>
              <i class="btn-close cursor-pointer" @click="close" :aria-label="t('onboardingBonds.close')"></i>
            </div>
            <div class="modal-body">
              <BondDetailContent :bond-id="bond.id" :advisor="advisor" embedded/>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-tenant" @click="close">{{ t('onboardingBonds.close') }}</button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
